import { ISkippedRow } from "@/api";
import { Table } from "@/components/shared/table/Table";
import { Box, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

interface IProps {
    skippedRows: ISkippedRow[];
}

/**
 * SkippedRowsList component - Displays details of skipped rows
 */
export const SkippedRowsList = ({ skippedRows }: IProps) => {
    const rows = skippedRows.map((row, index) => ({
        id: index,
        ...row,
    }));

    const columns: GridColDef[] = [
        {
            field: "sheet_name",
            headerName: "Sheet",
            width: 100,
            sortable: false,
        },
        {
            field: "row_number",
            headerName: "Row",
            width: 80,
            align: "center",
            headerAlign: "center",
            sortable: false,
        },
        {
            field: "reason",
            headerName: "Reason",
            flex: 1,
            minWidth: 300,
            sortable: false,
        },
    ];

    if (skippedRows.length === 0) {
        return null;
    }

    return (
        <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
                Skipped Row Details
            </Typography>
            <Table
                rows={rows}
                columns={columns}
                disableColumnMenu
                hideFooter
                disableColumnFilter
                disableColumnSorting
                autoHeight
                getRowHeight={() => "auto"}
                sx={{
                    "& .MuiDataGrid-cell": {
                        py: 1,
                    },
                }}
            />
        </Box>
    );
};
